import { trU } from '../../lib/i18n';
import { C } from '../../theme/palette';

export const Bar = ({ icon, title, right, color = C.navy, sub }) => (
  <div
    style={{ padding: '10px 14px', background: C.navyXL, borderBottom: '1px solid ' + C.border }}
  >
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
        {icon && <span style={{ fontSize: 13 }}>{icon}</span>}
        <span style={{ fontSize: 11, fontWeight: 800, color }}>{trU(title)}</span>
      </div>
      {right}
    </div>
    {sub && <div style={{ fontSize: 8, color: C.muted, marginTop: 2 }}>{sub}</div>}
  </div>
);
